import React from "react";
import { useTranslation } from "react-i18next";
import CommunicationPreferences from "./CommunicationPreferences";

/** Everyone except the Owner: their own optional SMS consent only, never the terms. */
const NotificationSettingsCard: React.FC<{ enabled: boolean }> = ({ enabled }) => {
  const { t } = useTranslation("consent");
  return (
    <div className="p-4 space-y-3 bg-white border border-gray-200 rounded-xl">
      <div className="flex items-center gap-2">
        <h4 className="font-semibold text-gray-900">{t("notifications.title")}</h4>
        <span className="px-2 py-0.5 text-[11px] font-medium text-green-700 bg-green-50 rounded-full">{t("new")}</span>
      </div>
      <CommunicationPreferences enabled={enabled} />
      <p className="text-xs text-gray-500">{t("notifications.optOutNote")}</p>
    </div>
  );
};

export default NotificationSettingsCard;
